import * as React from "react";
// 消息枚举
import { EWebSiteTemplate } from "utils/enum/notice";
// 登录模板
import LoginWSTmp from "./login_ws_tmp";
// 异常模板
import AbnormalWSTmp from "./abnormal-ws-tmp";
// 订单更新模板
import OrderUpdWSTmp from "./orderUpd-ws-tmp";
// 群组消息模板
import GroupWSTmp from "./group-ws-tmp";
// 客服消息模板
import NCSWSTmp from "./ncs-ws-tmp";
import moment from "moment";
// 消息枚举
import { ENoticeLevel, EReadStatus, ECollectStatus } from "utils/enum/notice";

// 转换服务端返回的消息类型
const transformNoticeType = info => {
  let noticeType = EWebSiteTemplate.Login;
  // 消息为普通消息，并且需要弹窗的是登录模板
  if (info.type == 1 && info.isPopup == true && (!info.to && !info.from)) {
    noticeType = EWebSiteTemplate.Login;
  }
  // 消息为异常订单提示的是异常订单模板
  else if (info.type == 2) {
    noticeType = EWebSiteTemplate.Abnormal;
  }
  // 消息为满位订单提示的是订单更新模板
  else if (info.type == 3) {
    noticeType = EWebSiteTemplate.OrderUpdate;
  }
  // 客服消息
  else if (info.type == 1 && (info.to || info.from)) {
    noticeType = EWebSiteTemplate.NCSNotice;
  } else {
    noticeType = info.type;
  }
  return noticeType;
};

// 转换原始数据来匹配模板参数
const transformData = data => {
  // 消息创建日期
  const nowDate = moment();
  const dataDate = moment(parseInt(data.create_time) * 1000);
  const formatStr =
    nowDate.year > dataDate.year ? "YYYY-MM-DD HH:mm" : "MM-DD HH:mm";

  data.createTime = dataDate.format(formatStr);
  // 未读
  data.isRead = parseInt(data.is_read) ? EReadStatus.Yes : EReadStatus.No;
  // 未收藏
  data.isCollect = parseInt(data.is_collection)
    ? ECollectStatus.Yes
    : ECollectStatus.No;
  // 消息级别
  data.isNoticeLevel = !!data.isPopup
    ? ENoticeLevel.Importance
    : ENoticeLevel.General;
  // 订单号
  data.orderNumber = data.orderNumer;
  // 消息发送者
  data.from = data.from;
};

// 根据消息类型选择不同模板来渲染消息
export default props => {
  let noticeType;
  let data = props.noticeList;
  data = data || [];
  console.log("renderData", data);
  return data.map((element, index) => {
    transformData(element);
    noticeType = transformNoticeType(element);
    const commonProps = { ...props, ...element };
    switch (noticeType) {
      case EWebSiteTemplate.Login:
        return <LoginWSTmp {...commonProps} key={index} />;
      case EWebSiteTemplate.Abnormal:
        return <AbnormalWSTmp {...commonProps} key={index} />;
      case EWebSiteTemplate.OrderUpdate:
        return <OrderUpdWSTmp {...commonProps} key={index} />;
      case EWebSiteTemplate.GroupNotice:
        return <GroupWSTmp {...commonProps} key={index} />;
      case EWebSiteTemplate.NCSNotice:
        return <NCSWSTmp {...commonProps} key={index} />;
      case EWebSiteTemplate.TemporaryNotice:
        return <NCSWSTmp {...commonProps} key={index} />;
      default:
        return [];
    }
  });
};
